import React, { useState } from 'react';
import LogoMain from '../images/Logo.png';
import { Image } from 'antd';
import eCoachVMSApi from '../Api';
import '../css/login.css';
// Login function (from your code)
const login = async (user_name, password) => {

  const { baseURL } = eCoachVMSApi();
  const response = await baseURL.get(`userLogin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_name, password }),
  });

  const data = await response.json();
  if (response.ok) {
    localStorage.setItem('token', data.token);
    return data;
  } else {
    throw new Error(data.error);
  }
};

// Fetch data with token (from your code)
const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
  };

  const response = await fetch(url, { ...options, headers });
  return response.json();
};

// Logout function (from your code)
const logout = () => {
  localStorage.removeItem('token');
  window.location.reload();
};

// React Login component
const Login = () => {
  const [user_name, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await login(user_name, password);
      setIsAuthenticated(true);
      setError('');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleLogout = () => {
    logout();
    setIsAuthenticated(false);
  };

  return (
    <div className="login-container">
      {!isAuthenticated ? (
        <form onSubmit={handleLogin}>
            <div className='logo'>
                <Image src={LogoMain} preview={false} style={{ objectFit: 'contain' }} />
                <span>Vehicle Management System</span>
            </div>
            <div className='form-wrap'>
                <div className='form-item'>
                    <label htmlFor="username">Login</label>
                    <input
                    type="text"
                    placeholder='User Name'
                    id="username"
                    value={user_name}
                    onChange={(e) => setUserName(e.target.value)}
                    required
                    />
                </div>
                <div className='form-item'>
                    <label htmlFor="password">Password</label>
                    <input
                    type="password"
                    id="password"
                    placeholder='Password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    />
                </div>
                {error && <p className="error">{error}</p>}
                <button type="submit">Login</button>
            </div>
        </form>
      ) : (
        <div>
          <h2>Welcome!</h2>
          <button onClick={handleLogout}>Logout</button>
        </div>
      )}
    </div>
  );
};

export default Login;
